import AdminFreshdeskSettings from './AdminFreshdeskSettings';

export default AdminFreshdeskSettings;
